<template>
  <div :class="iszzc ? 'noscroll' : 'shop'">
    <img class="add_car_img" v-if="isNewMode" :src="ossImgPath + 'new_card.png'" alt @click="goCar" />
    <img class="add_car_img" v-else :src="ossImgPath + 'icon-shoppingcart.png'" alt @click="goCar" />
    <img
      class="add_car_img share_newMode"
      v-if="isNewMode"
      :src="ossImgPath + 'share_new.png'"
      alt
      @click="shareImage"
    />
    <img v-if="isNewMode" class="goPre" @click="goPre" :src="ossImgPath+ 'fanhui.png' " alt />
    <div v-else class="goPre" @click="goPre">
      <qdd-icon class="icon07jiantouxiangzuofill" color="#333" size="1.5rem"></qdd-icon>
    </div>

    <!-- 轮播-->
    <div class="swiper">
      <van-swipe
        class="my-swipe"
        duration="500"
        autoplay="3000"
        indicator-color="white"
        @change="onChange"
      >
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <img class="swiper_img" :src="item" />
        </van-swipe-item>
        <div
          class="custom-indicator"
          :class="{'NewMode':isNewMode}"
          slot="indicator"
        >{{ current + 1 }}/{{ swiperList.length }}</div>
      </van-swipe>

      <van-swipe
        class="my-swipe_vertical"
        v-if="isNewMode && OrderHistory.length >0"
        :autoplay="1200"
        :touchable="false"
        :show-indicators="false"
        vertical
      >
        <van-swipe-item v-for="(item,index) in OrderHistory" :key="index" class>
          <p class="t_line swiper_text_x">{{item.describe}}</p>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="new_mode_content" v-if="isNewMode">
      <div class="top_orange flex_b">
        <div class="left_max_jifen flex">
          <strong>{{ shopData.jinbi }}</strong>
          <span>积分</span>
          <b>{{storeInfo.is_show_retail_price == 1 ?'建议兑换:'+ shopData.retail_price_format : '' }}</b>
        </div>
        <div v-if="shopData.sales_text !=''">
          <div class="hot_targ">
            <qdd-icon name="iconhuomiao" class="icon" size="0.45rem" color="#ffffff"></qdd-icon>
            {{ shopData.sales_text }}
          </div>
        </div>
      </div>
      <div class="goods_desx_box_x">
        <p class="goods_name">{{shopData.goods_name}}</p>
        <div
          class="targ_max_box flex_b"
          v-if="shopData.new_products.name !='' ||  shopData.rank_tag !='' || shopData.brand.name != '' || shopData.goods_type==2 || shopData.rank_text !=''  "
        >
          <div>
            <!-- <span>当日上新</span> -->
            <span
              class="targ_i"
              :style="{background:colorList[shopData.new_products.ptype-1] }"
              v-if="shopData.new_products && shopData.new_products.name !=''"
            >{{shopData.new_products.name}}</span>
            <span class="orange_bg" v-if="shopData.rank_tag !=''">{{shopData.rank_tag}}</span>
            <span
              class="black"
              v-if="shopData.brand && shopData.brand.name != '' "
            >{{shopData.brand.name}}</span>
            <span class="targ_store" v-if="shopData.goods_type==2">门店</span>
          </div>

          <div v-if="shopData.rank_text != ''" @click="jump('/Ranking?type=2')">
            <!-- <qdd-icon name="iconhuomiao" class="icon" size="0.45rem" color="#FA1549"></qdd-icon> -->
            <img class="hot_img_t" :src="ossImgPath+'hot_q.png'" alt />
            {{shopData.rank_text}}
          </div>
        </div>
        <div class="flex_a characteristic">
          <div class="flex">
            <img :src="ossImgPath+'value1.png'" alt />积分省钱
          </div>
          <div class="flex">
            <img :src="ossImgPath+'value2.png'" alt />品类齐全
          </div>
          <div class="flex">
            <img :src="ossImgPath+'value3.png'" alt />大牌兑换
          </div>
          <div class="flex">
            <img :src="ossImgPath+'value.png'" alt />售后保障
          </div>
        </div>
      </div>
    </div>
    <!--  内容-->
    <div class="shop_main" v-else>
      <div class="title">
        <span class="cor">【{{ isStore ? '本店兑换' : '商城兑换' }}】</span>
        <span>{{ shopData.goods_name }}</span>
      </div>

      <div class="integral_price">
        <div class="price">
          <span>
            {{ shopData.jinbi }}
            <b>积分</b>
          </span>
          <img :src="ossImgPath + 'fx.png'" v-if="shareImg" alt @click="shareImage" />
        </div>
        <div class="cs_price">
          <b
            class="fl"
          >{{storeInfo.is_show_retail_price == 1 ? '建议兑换:'+shopData.retail_price_format : '' }}</b>
          <em class="fr">已兑：{{ shopData.sales }}</em>
        </div>
      </div>
    </div>

    <!-- 地址 -->
    <div class="flex_b city" :class="isNewMode?'new_city_s': ''" @click="goCityList">
      <div class="send">{{ isStore ? '自提地址' : '送至' }}</div>
      <div class="flex">
        <span class="city_title t_line">{{ shopData.address || '请设置收货地址' }}</span>
        <qdd-icon v-if="!isStore" class="iconright" color="#999999" size=".5rem"></qdd-icon>
      </div>
    </div>

    <div class="more_suggest" v-if="isNewMode && shopData &&shopData.more_recommend.length>0 ">
      <p class="text_h1">更多推荐</p>
      <div>
        <ul>
          <li
            v-for="(item,idx) in shopData.more_recommend"
            :key="idx"
            @click="goPathUrl(item.goods_id)"
          >
            <img :src="item.goods_image" alt />
            <p class="t_line2">{{item.goods_name}}</p>
            <div class="price">
              <strong>{{item.jinbi}}</strong>积分
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!--商品详情-->
    <div class="shop_det">
      <div class="shop_title">{{isNewMode?'商品详情':'产品详情'}}</div>
      <!--           <img :src="ossImgPath+'fx.png'" alt="" />-->
      <div class="shop_del" :class="isNewMode?'new_img_Box':''" v-html="shopData.description"></div>
    </div>

    <!--  footer 底部 -->
    <div class="flex bot new_footer" v-if="isNewMode">
      <div class="flex">
        <div class="collection left_home" @click="goHome">
          <img :src="ossImgPath + 'home.png'" />
          <div>首页</div>
        </div>
        <div class="collection" @click="addCollect">
          <img v-if="is_collection" :src="ossImgPath + 'collection2.png'" />
          <img v-else :src="ossImgPath + 'collection.png'" />
          <div>收藏</div>
        </div>
      </div>
      <div class="flex operation" v-if="!isStore">
        <div class="add_car" @click="addCarBtn">加入购物车</div>
        <div @click="addCarBtn">立即兑换</div>
      </div>
      <div class="flex operation mendian_btn" @click="addCarBtn" v-if="isStore">
        <p style="width: 100%">门店兑换</p>
      </div>
    </div>
    <div class="flex bot" v-else>
      <div class="collection" @click="addCollect">
        <img v-if="is_collection" :src="imgPath + 'icon_shoucang.png'" />
        <img v-else :src="imgPath + 'icon_wshoucang.png'" />
        <div>收藏</div>
      </div>
      <div class="flex operation" v-if="!isStore">
        <div class="add_car" @click="addCarBtn">加入购物车</div>
        <div @click="addCarBtn">立即兑换</div>
      </div>
      <div class="flex operation mendian_btn" @click="addCarBtn" v-if="isStore">
        <p style="width: 100%">门店兑换</p>
      </div>
    </div>

    <!--  分享  -->
    <div class="mod" v-if="isShare">
      <div class="share_pop">
        <div class="flex">
          <span>
            <qdd-icon class="iconweixin2" color="#52DA37" size="1rem"></qdd-icon>
            <b>微信好友</b>
          </span>
          <span @click="shareImage">
            <qdd-icon class="iconxuanchuanhaibao" color="#2F96FF" size="0.8rem"></qdd-icon>
            <b>海报分享</b>
          </span>
        </div>
        <p @click="goCancle">取消</p>
      </div>
    </div>

    <!--  加入购物车 和立即购买 选择规格-->
    <div class="cart_contant" v-if="iszzc">
      <div class="cart_contant_warp">
        <div class="close" @click="closeBtn">
          <qdd-icon class="iconx" color="#333" size="1rem"></qdd-icon>
        </div>
        <div class="cart_good">
          <img :src="curSpecImg || swiperList[0]" />
          <span>
            <em class="fl">{{ shopData.jinbi }}</em>
            <b class="fl">积分</b>
          </span>
          <p>已兑：{{ shopData.sales }}</p>
        </div>

        <div class="cart_good_size" v-if="shopData.is_show_spec == 1 ">
          <p>规格</p>
          <ul>
            <li
              v-for="(item, index) in specLst"
              :key="index"
              :class="id == item.id ? 'active' : ''"
              @click="choice(item.id)"
            >
              {{ item.spec_1 }}
              <template v-if="item.spec_2">,{{ item.spec_2 }}</template>
              <template v-if="item.spec_3">,{{ item.spec_3 }}</template>
            </li>
          </ul>
        </div>

        <div class="cart_good_size">
          <p class="fl">兑换数量</p>

          <div class="flex sort">
            <img
              @click="shopNumFg"
              data-type="back"
              :src="
                imgPath +
                  (shopNum <= 1 || shopNum <= qidingliang
                    ? 'jianqubkeidan'
                    : 'jianqukdjskeidnaj') +
                  '.png'
              "
            />
            <input
              :value="shopNum"
              @blur="shopNumBlur"
              @input="shopNumFg"
              type="number"
              data-type="input"
            />
            <img @click="shopNumFg" data-type="add" :src="imgPath + 'dianikqdian.png'" />
          </div>
        </div>
        <div class="sf_exchangetip">
          默认兑换数量为{{ qidingliang }}
          <!-- <span v-if="shopData.is_skip_dabao == 0"> -->
            ，批量兑换请填写{{
            shopData.dabao_o_num
            }}的倍数！
          <!-- </span> -->
        </div>

        <div class="cart_good_size" v-if="courier.length > 0">
          <p class="fl">配送方式</p>

          <div
            class="fr"
            v-if="logistics.if_free_shipping == '0' && logistics.is_calc_freight == 1"
          >
            <span>{{ logistics.freight_format }}元</span>
          </div>
          <div class="fr" v-if="logistics.if_free_shipping == '1'">
            <span>{{logistics.free_shipping}}</span>
          </div>
          <div
            class="fr"
            v-if="logistics.if_free_shipping == '0' && logistics.is_calc_freight != 1"
          >
            <span class="color9" v-if="logistics.freight_payer ==1">
              (预估):
              {{logistics.freight_format}}元
            </span>
            {{logistics.free_shipping}}
          </div>

          <ul class="kuaidi">
            <li
              v-for="(item, index) in courier"
              :key="index"
              :class="freigId == item.code ? 'active' : ''"
              @click="cltyChoice(item.code)"
            >{{ item.name }}</li>
          </ul>
        </div>

        <div class="cart_footer">
          <div v-if="!isStore">
            <button @click="optimalsolution(false)">加入购物车</button>
            <button class="redbg" @click="optimalsolution(true)">立即兑换</button>
          </div>
          <button v-else class="mendian" @click="redeem">门店兑换</button>
        </div>
      </div>
    </div>
    <mloading v-if="showLoading"></mloading>
    <div v-if="showShareImage" class="share_image">
      <div class="shareImg">
        <img :src="shareImg" mode />
        <div class="save_code">长按图片保存到手机</div>
        <div class="over_code" @click="clearShare">关闭</div>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="tankuang_zhezhaoceng" v-if="isshowhidden">
      <div class="tank_zzc">
        <div class="tank_title">温馨提示</div>
        <p class="tkzzc">
          此商品物流费约
          <span>{{logisticsInfor.now_freight}}</span>
          元,{{logisticsInfor.min_yf_mode_name}}运费为
          <span>{{logisticsInfor.min_freight}}</span>元,是否切换
        </p>
        <div class="Determinetocancel">
          <p @click="ascertain">确定</p>
          <p @click="cancel">取消</p>
        </div>
      </div>
    </div>
    <!-- H黑名单和储备金弹框 -->
    <div class="tankuang_zhezhaoceng" v-if="isReserve">
      <div class="tank_zzc">
        <div class="tank_title">温馨提示</div>
        <p class="tkzzc">{{showModalMain}}</p>
        <div class="Determinetocancel">
          <p @click="cancel('isreserve')">取消</p>

          <p @click="callBtn(storeInfo.phone_mob)">
            <a :href="'tel:' + storeInfo.phone_mob">立即联系</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icon from '@/components/iconfont.vue'
import { sendRequest, getOpenid } from '@/assets/public'
import mloading from '@/components/loading.vue'
import { Dialog, Toast } from 'vant'
import share from '../../share.js'
import urlconfig from '@/config.js'

export default {
  components: {
    'qdd-icon': icon,
    mloading,
  },
  data() {
    return {
      colorList: ['#00B97C', '#FF5736', '#FFBE00', '#F40923'],
      showLoading: false,
      current: 0, // 当前轮播位置
      isStore: false, //是否本店兑换
      isShare: false, // 是否分享
      iszzc: false, //是否显示规格弹框
      shopNum: 1, // 数量
      qidingliang: 1, // 起订量
      id: '',
      swiperList: [], // 轮播图
      shopData: {}, // 商品数据
      is_collection: true, // 是否收藏
      specLst: [], // 规格
      courier: [], // 配送方式
      stock: 9999999, // 库存
      cityId: '',
      specId: 0,
      freigId: 0,
      curSpecImg: '', //对应规格图片
      classUrl: '', // 是否分类过来的链接
      collectUrl: '', // 是否收藏过来的链接
      showShareImage: false,
      shareImg: '',
      isLogin: localStorage.getItem('token'), //是否登录
      storeInfo: {},
      logistics: {}, // 物流后的价格
      store_id: 0,
      logisticsInfor: {}, // 物流信息
      exchange: false,
      isshowhidden: false,
      isReserve: false,
      isNewMode: localStorage.getItem('isNewMode'), //20240312改版
      OrderHistory: [],
    }
  },
  watch: {
    iszzc(val) {
      if (val && this.specLst.length < 1) {
        this.speciInfor()
      }
    },
    id(val) {
      let _this = this
      console.log(val, this.specLst, _this.id)
      this.specLst.forEach((item) => {
        if (item.id == _this.id) {
          _this.curSpecImg = item.spec_image
        }
      })
    },
  },
  created() {
    console.log('茶韵关键----')
    if (this.isNewMode) {
      this.isNewMode = 1
      this.getOrderHistory()
    }
    this.classUrl = this.$route.query.surl
    this.collectUrl = this.$route.query.collectUrl
    this.id = this.$route.query.id || this.$route.params.id
    this.addr_id = this.$route.query.addr_id || this.$route.params.addr_id
    console.log(this.addr_id)
    document.title = '商品详情'
    this.goodDetails()
    this.getImageErar()
    this.storeInfoFg()
  },

  mounted() {
    // alert(localStorage.getItem('isNewMode'),'222')
    let isJump = JSON.parse(localStorage.getItem('isJump'))
    if (isJump == true) {
      localStorage.removeItem('isJump')
      return
    }
    let search = window.location.href.split('?')[1]
      ? window.location.href.split('?')[1].split('code=')[1]
      : ''

    console.log(window.location.href.split('?')[1].split('code=')[1])
    if (search && !localStorage.getItem('token')) {
      let that = this
      getOpenid(
        search.indexOf('&') > -1 ? search.split('&')[0] : search,
        '#/login',
        window.encodeURIComponent(
          `${urlconfig.goPath}shopDetail?id=${this.id}`
        ),
        that.getImageErar
      )
    }
  },

  methods: {
    jump(url) {
      this.$router.push(url)
    },
    goHome() {
      this.$router.push('/')
    },
    goPathUrl(id) {
      this.$router.replace({ path: '/shopDetail', query: { id: id } })
      window.location.reload()
      // this.id=id
      // let routeUrl =  this.$router.resolve({
      // 	path:'/shopDetail',
      // 	query:{id:id}
      // });
      // window.open(routeUrl.href, '_blank')
    },
    storeInfoFg() {
      sendRequest('user/storeInfo').then((result) => {
        if (result.status == 200) {
          let store_info = result.content.store
          this.storeInfo = result.content.store
          // 2024.3.12新增模版

          if (result.content.store.mark_id >= 21) {
            localStorage.setItem('isNewMode', 1)
            this.isNewMode = 1
          } else {
            localStorage.removeItem('isNewMode')
            this.isNewMode = 0
          }
        }
      })
    },
    getOrderHistory() {
      let data = {
        goods_type: 2,
        goods_id: this.$route.query.id || this.$route.params.id,
      }
      sendRequest('goods/orderHistory', data).then((result) => {
        if (result.status == 200) {
          this.OrderHistory = result.content
        }
      })
    },
    // 关闭
    clearShare() {
      this.showShareImage = false
    },
    shareImage() {
      if (!this.isLogin) {
        this.gologin()
        return
      }
      this.showShareImage = true
    },
    // 获取分享图
    async getImageErar() {
      let params = {
        stock_id: this.id,
      }
      let { content, status } = await sendRequest('goods/goodsPoster', params)
      if (status == 200) {
        this.isLogin = localStorage.getItem('token')
        this.shareImg = content.url + content.object
      }
      // console.log(content)
    },
    onChange(index) {
      this.current = index
    },
    //商品详情左上角返回
    goPre() {
      if (this.classUrl) {
        this.$router.push({
          path: 'classify',
        })
      } else if (this.collectUrl == 1) {
        this.$router.go(-1)
      } else {
        this.$router.go(-1)
        // this.$router.push('/')
      }
    },
    goShare() {
      this.isShare = true
    },
    goCancle() {
      this.isShare = false
    },
    addCarBtn() {
      this.iszzc = true
    },
    closeBtn() {
      this.iszzc = false
    },
    // 商品详情
    async goodDetails(isload) {
      let params = {
        id: this.id,
        addr_id: this.addr_id ? this.addr_id : null,
      }
      this.showLoading = true
      let { content, status } = await sendRequest('goods/detail', params)
      this.showLoading = false
      // console.log(content)
      if (status != 200) {
        return
      }

      localStorage.setItem('store_id', content.goods.store_id)
      this.store_id = content.goods.store_id

      let goods_images = []
      let goods = content.goods
      for (let i in goods.goods_images) {
        goods_images.push(goods.goods_images[i])
      }
      this.swiperList = goods_images // 轮播图
      this.isStore = goods.goods_type == 2 || goods.goods_type == 0 // 是否是店铺兑
      this.is_collection = goods.is_collection
      goods.dabao_o_num =  goods.dabao_num
      goods.dabao_num = goods.is_skip_dabao == 1 ? 1 : goods.dabao_num
     
      console.log()
      this.shopData = goods
      this.cityId = goods.addr_id
      this.getYfMode()
      if (goods.stock == 0 && goods.goods_type == 2) {
        Toast('库存不足')
        this.shopNum = 0
        this.stock = goods.stock
      }
      // 产品要求改的
      // let gos_qidingliang = Number(goods.qidingliang)
      // let gos_qidingliang = Number('1')
      let gos_qidingliang = Number(goods.sampling_num)
      // let qidingliang = goods.goods_type == 1 ? gos_qidingliang : goods.wl_qidingliang
      this.qidingliang = gos_qidingliang || 1
      this.shopNum =
        this.shopNum < gos_qidingliang ? gos_qidingliang : this.shopNum
      document.body.scrollTop = document.documentElement.scrollTop = 0
      new share({
        goods_images: goods_images[0],
        goods_name: goods.goods_name,
      })
    },

    // 收藏
    async addCollect() {
      if (!this.isLogin) {
        this.gologin()
        return
      }

      this.showLoading = true
      let { status, msg } = await sendRequest(
        this.shopData.is_collection ? 'goods/delCollect' : 'goods/addCollect',
        {
          stock_id: this.id,
        }
      )
      this.showLoading = false
      if (status == '2321' || status == '200') {
        Toast(this.shopData.is_collection ? '取消收藏！' : '收藏成功！')
        this.goodDetails()
      } else {
        Toast(msg)
      }
    },
    // 规格
    async speciInfor() {
      let params = {
        xhq_id: this.id,
        addr_id: this.cityId,
      }
      let { status, content } = await sendRequest('goods/info', params)
      if (status != 200) {
        return
      }

      let specLst = []
      for (let i in content.spec) {
        if (i.spec_name != '') {
          specLst.push(content.spec[i])
          if (this.id == content.spec[i].id) {
            this.curSpecImg = content.spec[i].spec_image
          }
        }
      }
      this.specLst = specLst
      this.cltyChoicePice()
    },
    // 选择规格
    choice(event) {
      // console.log(event)
      if (this.id == event) {
        return
      }

      this.id = event
      this.goodDetails()
    },
    // 配送方式
    async getYfMode() {
      let params = {
        xhq_id: this.id,
        addr_id: this.cityId,
      }
      let { content, status } = await sendRequest('goods/getYfMode', params)
      if (status != 200) {
        return
      }
      let yf_mode = []
      for (let i in content.yf_mode) {
        for (let j in content.yf_mode[i]) {
          yf_mode.push(content.yf_mode[i][j])
        }
      }
      this.courier = yf_mode
      console.log(this.courier, '99999999999999')
      this.freigId = yf_mode.length > 0 ? this.freigId || yf_mode[0].code : ''
    },
    // 数量添加
    shopNumFg(e) {
      let { type } = e.target.dataset
      let { shopNum, stock, qidingliang, shopData } = this
      let dabao_num = parseInt(shopData.dabao_num)
      if (type == 'add') {
        if (shopNum % dabao_num != 0) {
          shopNum = dabao_num
        } else {
          shopNum = shopNum + dabao_num
        }
      }
      if (type == 'back' && shopNum > 1 && shopNum > qidingliang) {
        shopNum = shopNum - dabao_num
        if (shopNum < this.qidingliang) {
          shopNum = this.qidingliang
        }
      }
      if (type == 'input') {
        shopNum = Number(e.target.value) == 0 ? '' : Number(e.target.value)
      }
      if (shopNum > stock) {
        shopNum = stock
      }
      this.shopNum = shopNum
      this.cltyChoicePice()
    },
    shopNumBlur() {
      if (this.shopNum == '' || this.shopNum < this.qidingliang) {
        this.shopNum = this.qidingliang
      }
    },

    // 立即兑换
    async redeem() {
      if (!this.isLogin) {
        this.gologin()
        return
      }

      if (!this.cityId && !this.isStore) {
        this.cityFg()
        return
      }
      let { id, stock, shopData, qidingliang, shopNum, freigId } = this
      let dabao_num = parseInt(shopData.dabao_num)
      // if (shopNum != qidingliang && shopNum % dabao_num != 0) {
      //   showToast(
      //     '默认购买为' +
      //       qidingliang +
      //       '，批量购买请填写' +
      //       dabao_num +
      //       '的倍数！'
      //   )
      //   return
      // }
      this.showLoading = true
      let share_id = this.$route.query.share_id
        ? this.$route.query.share_id
        : ''

      let { status, content, msg } = await sendRequest('cart/add', {
        id: id,
        num: shopNum,
        yf_mode: freigId,
        cart_type: 1,
        addr_id: this.cityId,
        share_id: share_id,
      })
      this.showLoading = false
      if (status == '2057') {
        this.showModalMain = `对不起，本店商品储备金出现问题，暂时无法兑换，请联系我们调整，电话：${this.storeInfo.phone_mob}`
        this.isReserve = true
        return
      } else if (status == '2056') {
        this.showModalMain = `商城企业信息需重新认证，请联系商家！`
        this.isReserve = true
        return
      }
      if (status != '200') {
        // alert(1)h
        Toast(msg)

        return
      } else {
        Toast(msg)
      }
      // this.$router.push({
      //   name: 'orderConfirm',
      //   params: {
      //     ids: content.id,
      //     cart_type: '1',
      //     goods_type:,
      //   },
      // })
      this.$router.push({
        path:
          '/orderConfirm?ids=' +
          content.id +
          '&cart_type=1&goods_type=' +
          this.shopData.goods_type,
      })
    },
    // 地址
    cityFg() {
      Dialog.confirm({
        title: '提示',
        message: '你目前还未设置地址，是否立即设置？',
      })
        .then(() => {
          // on confirm
          this.$router.push({
            path: '/addressAddto?modification=add',
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 切换收货方式
    cltyChoice(event) {
      this.freigId = event
      this.cltyChoicePice()
    },

    // 切换物流的价格
    async cltyChoicePice() {
      let params = {
        xhq_id: this.id,
        num: this.shopNum,
        yf_mode: this.freigId,
        addr_id: this.cityId, // 地址id
      }
      let { status, content, msg } = await sendRequest(
        'goods/getGoodsFreight',
        params
      )
      if (status == '200') {
        this.logistics = content
      }
    },

    // 跳转
    goCityList() {
      console.log('111', this.isLogin)
      if (!this.isLogin) {
        this.gologin()
        return
      }
      if (this.isStore) {
        return
      }
      let url = this.cityId
        ? '/addressList?isDetails=true&addr_id=' +
          this.cityId +
          '&id=' +
          this.id
        : '/addressAddto?modification=add&goodsId=' + this.$route.query.id
      this.$router.push({
        path: url,
      })
    },
    goCar() {
      this.$router.push({
        path: '/cart',
      })
    },
    cancel(e) {
      if (e == 'isreserve') {
        this.isReserve = false
        return
      }
      if (this.exchange) {
        this.redeem()
      } else {
        this.addCar()
      }
      this.isshowhidden = false
    },
    ascertain() {
      this.isshowhidden = false
      this.cltyChoice(this.logisticsInfor.min_yf_mode)
    },
    optimalsolution(verdict) {
      if (!this.isLogin) {
        this.gologin()
        return
      }
      this.exchange = verdict
      let params = {
        xhq_id: this.id,
        num: this.shopNum,
        yf_mode: this.freigId,
        addr_id: this.cityId, // 地址id
        store_id: this.store_id,
      }
      this.showLoading = true

      sendRequest('goods/compareGoodsFreight', params).then((res) => {
        if (res.status == '200') {
          this.logisticsInfor = res.content

          if (res.content.is_need_pop) {
            this.isshowhidden = res.content.is_need_pop
            console.log(this.isshowhidden)

            // Dialog.confirm({
            //   title: '提示',
            //   message:
            //     '此商品物流运费约' +
            //     res.content.now_freight +
            //     ',' +
            //     this.courier[res.content.min_yf_mode - 1].name +
            //     '运费为' +
            //     res.content.min_freight +
            //     '元，是否切换',
            // })
            //   .then(() => {
            //     this.cltyChoice(res.content.min_yf_mode)
            //   })
            //   .catch(() => {
            //     if (this.exchange) {
            //       // 加入购物车
            //       this.redeem()
            //     } else {
            //       this.addCar()
            //     }
            //   })
          } else {
            if (this.exchange) {
              // 加入购物车
              this.redeem()
            } else {
              this.addCar()
            }
          }
        }
      })
      this.showLoading = false
    },
    // 加入购物车
    addCar() {
      if (!this.isLogin) {
        this.gologin()
        return
      }
      if (!this.cityId && !this.isStore) {
        this.cityFg()
        return
      }
      let { id, shopNum, freigId, shopData, qidingliang, cityId } = this
      let dabao_num = parseInt(shopData.dabao_num)
      // if (shopNum != qidingliang && shopNum % Number(dabao_num) != 0) {
      //   Toast(
      //     '默认购买数量为' +
      //       qidingliang +
      //       '，批量购买请填写' +
      //       dabao_num +
      //       '的倍数！'
      //   )
      //   return
      // }
      let share_id = this.$route.query.share_id
        ? this.$route.query.share_id
        : ''
      let params = {
        id: id,
        num: shopNum,
        yf_mode: freigId,
        addr_id: cityId, // 地址id
        share_id: share_id,
      }
      this.showLoading = true
      sendRequest('cart/add', params).then((res) => {
        if (res.status == '2057') {
          this.showModalMain = `对不起，本店商品储备金出现问题，暂时无法兑换，请联系我们调整，电话：${this.storeInfo.phone_mob}`
          this.isReserve = true
          return
        } else if (res.status == '2056') {
          this.showModalMain = `商城企业信息需重新认证，请联系商家！`
          this.isReserve = true
          return
        }
        if (res.status == '200') {
          Toast('加入成功')
          this.iszzc = false
        } else {
          Toast(res.msg)
        }
      })
      this.showLoading = false
    },

    gologin() {
      this.Dialog.confirm({
        message: '请先登录',
        confirmButtonText: '登录',
      }).then(() => {
        if (this.isWexinLogin) {
          var appid = 'wxcef271c70c3c8428' // appid
          var url = window.encodeURIComponent(
            `${urlconfig.goPath}shopDetail?id=${this.id}`
          ) // 回调链接地址，需转码为URI格式，必须去除#后的参数
          var scope = 'snsapi_base' // snsapi_base静默授权，snsapi_userinfo弹出授权页面
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`
        } else {
          localStorage.setItem('isJump', JSON.stringify(true))
          this.$router.push('/login')
        }
      })
    },

    async getOpenid(code) {
      let { content, status } = await sendRequest('user/login_wx', {
        code: code,
      })
      if (status == 2318) {
        localStorage.setItem(
          'pages',
          JSON.stringify({
            path: '/personalCenter',
            query: {},
          })
        )
        window.location.href = window.location.href.split('?')[0] + '#/login'
      }
      if (status == 200) {
        localStorage.setItem('token', content.token)
        localStorage.setItem('infor', JSON.stringify(content))

        this.getImageErar()
      }
    },
    callBtn(e) {},
  },
}
</script>
<style>
.my-swipe_vertical.van-swipe {
  top: inherit !important;
  position: absolute !important;
  /* width: auto; */
}
.my-swipe_vertical .van-swipe-item {
  width: 100% !important;
}
</style>
<style scoped>
.tankuang_zhezhaoceng {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  z-index: 500;
}

.tank_zzc {
  width: 85%;
  height: 200px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.tank_title {
  text-align: center;
  line-height: 40px;
  color: #333;
  font-weight: 600;
  font-size: 16px;
  margin-top: 18px;
}

.tkzzc {
  box-sizing: border-box;
  margin: 0 40px 10px;
  font-size: 16px;
  color: #919191;
}

.tkzzc span {
  color: #fb0202;
}

.Determinetocancel {
  display: flex;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eaeaea;
  line-height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.Determinetocancel p {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}

.Determinetocancel p:nth-child(2) a {
  width: 100%;
  height: 100%;
  display: block;
  color: #6b80a5;
}

.Determinetocancel p + p {
  border-left: 1px solid #eaeaea;
}

/*选择规格*/
.mendian {
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
  width: 15rem !important;
}

.mendian_btn {
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
}
.new_footer.bot .operation.mendian_btn {
  width: 4.8rem;
  margin-right: 0.4rem;
  height: 1.44rem;
  line-height: 1.44rem;
  border-radius: 0.72rem;
  margin-top: 0.22rem;
  background: #ff463a;
}

.cart_footer {
  display: flex;
}

.cart_footer button {
  width: 7.5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background: #ff6d20;
}

.cart_footer button.redbg {
  background: #fd3e3e;
}
.hot_img_t {
  width: 0.44rem;
  height: 0.56rem;
  margin-top: -0.1rem;
  vertical-align: middle;
}

.cart_contant {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  /* height: 100%; */
  z-index: 105;
  overflow: hidden;
}

.cart_contant_warp {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  /*padding: 0 0.8rem 0.4rem;*/
  z-index: 105;
}

.cart_good {
  position: relative;
  font-size: 0.48rem;
  color: #999999;
  height: 3.2rem;
  margin: 0 0.8rem 0.4rem;
}

.cart_good img {
  width: 4rem;
  height: 4rem;
  border-radius: 10px;
  position: absolute;
  top: -0.8rem;
  left: 0;
}

.cart_good span {
  font-size: 0.72rem;
  color: #fd3e3e;
  padding-left: 4.6rem;
  padding-top: 0.6rem;
  display: block;
  overflow: hidden;
  line-height: 0.72rem;
  display: flex;
  align-items: center;
}

.cart_good p {
  padding-left: 4.6rem;
  color: #999999;
  font-size: 0.48rem;
  padding-top: 0.4rem;
}

.cart_good span b {
  width: 1.4rem;
  height: 0.56rem;
  line-height: 0.66rem;
  border: 1px solid rgba(253, 62, 62, 1);
  font-size: 0.4rem;
  color: #fd3e3e;
  border-radius: 14px;
  text-align: center;
  margin-top: 0.05rem;
  margin-left: 0.2rem;
}

.cart_good_size {
  padding-top: 0.8rem;
  overflow: hidden;
  margin: 0 0.8rem 0.4rem;
}

.cart_good_size .active {
  color: #fff !important;
  background: #fd3e3e !important;
  border: 1px solid #fd3e3e !important;
}

.cart_good_size .no_active {
  color: #fff !important;
  background: #dddddd !important;
  border: 1px solid #dddddd !important;
}

.cart_good_size p {
  color: #333333;
  font-size: 0.6rem;
}

.cart_good_size ul {
  display: flex;
  flex-flow: wrap;
}

.cart_good_size ul li:nth-child(3n) {
  margin-right: 0;
}

.cart_good_size ul li {
  float: left;
  min-width: 3.1rem;
  height: 0.96rem;
  line-height: 0.96rem;
  text-align: center;
  background: #fff;
  border: 1px solid #dddddd;
  border-radius: 0.2rem;
  color: #999;
  margin-right: 0.4rem;
  margin-top: 0.4rem;
}

.kuaidi {
  width: 100%;
}

.cart_good_size .kuaidi li:nth-child(4n) {
  margin-right: 0;
}

.cart_good_size .kuaidi li:nth-child(3n) {
  margin-right: 0.4rem;
}

.cart_good_size .kuaidi li {
  padding: 0 0.4rem;
}

.share_pop {
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  width: 100%;
  z-index: 102;
}

.share_pop p {
  text-align: center;
  font-size: 0.6rem;
  color: #8b8b8b;
  border-top: 1px solid #eee;
  line-height: 1.96rem;
}

.share_pop div {
  padding: 0.6rem 0;
  color: #999999;
  font-size: 0.56rem;
}

.share_pop span {
  width: 7.5rem;
  display: block;
  text-align: center;
}

.share_pop span b {
  display: block;
  width: 7.5rem;
  padding-top: 0.4rem;
}

.cor {
  color: #fd3e3e;
}

.add_car_img {
  width: 1.4rem;
  height: 1.4rem;
  position: fixed;
  right: 0.4rem;
  top: 0.4rem;
  padding: 0.2rem;
  z-index: 99;
}

.goPre {
  width: 1.4rem;
  height: 1.4rem;
  position: fixed;
  left: 0.4rem;
  top: 0.2rem;
  padding: 0.2rem;
  z-index: 9999;
}

.swiper {
  width: 100%;
  height: 15.08rem;
  position: relative;
}

.swiper_img {
  width: 100%;
  height: 100%;
  display: block;
  border: none;
}

.my-swipe {
  height: 100%;
}

.custom-indicator {
  position: absolute;
  width: 1.6rem;
  height: 0.96rem;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  left: 50%;
  bottom: 0.4rem;
  transform: translate(-50%, 0);
  border-radius: 0.48rem;
  font-size: 0.48rem;
  line-height: 0.96rem;
  text-align: center;
}

/* 商品内容 */
.shop_main {
  padding: 0.6rem 0.8rem;
  background: #ffffff;
}

.title {
  font-size: 0.6rem;
  color: #171717;
  line-height: 0.8rem;
  /* max-height: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
  text-align: left;
}

.integral_price .price {
  color: #fd3e3e;
  font-size: 0.72rem;
  line-height: 0.72rem;
  padding-top: 0.52rem;
  display: flex;
  justify-content: space-between;
}
.integral_price .price span {
  display: flex;
  align-items: center;
}

.integral_price .price b {
  width: 1.4rem;
  height: 0.56rem;
  text-align: center;
  display: inline-block;
  line-height: 0.64rem;
  color: #fd3e3e;
  font-size: 0.4rem;
  border: 1px solid rgba(253, 62, 62, 1);
  border-radius: 14px;
}

.integral_price .price img {
  float: right;
  width: 0.8rem;
  height: 0.8rem;
}

.integral_price .cs_price {
  font-size: 0.48rem;
  color: #999999;
  padding: 0.4rem 0;
}

/* 地址 */
.city {
  padding: 0.6rem 0.8rem;
  background: #ffffff;
  margin-top: 0.4rem;
}

.send {
  font-size: 0.56rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.6rem;
}

.city_title {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.6rem;
  width: 9rem;
  text-align: right;
}

/* 商品详情 */

.shop_title {
  padding: 0.8rem 0;
  text-align: center;
  font-size: 0.64rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

/*    footer*/
.opera {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #f4f6f8;
  z-index: 100;
}

.bot {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 2rem;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #f4f6f8;
  z-index: 100;
}

.collection {
  width: 2rem;
  padding-top: 0.4rem;
  text-align: center;
}

.collection img {
  width: 0.6rem;
  height: 0.54rem;
}

.collection div {
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.6rem;
}

.operation {
  flex: 1;
}

.operation div {
  width: 50%;
  background: #fd3e3e;
  color: #ffffff;
  font-size: 0.6rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  line-height: 2rem;
}

.operation .add_car {
  background: #ff6d20;
}

/* 规格 */
.specific {
  margin-top: 0.8rem;
}

.opera_title {
  font-size: 0.6rem;
  color: rgba(51, 51, 51, 1);
  line-height: 1.04rem;
}

.speci_list {
  flex-wrap: wrap;
}

.speci_list .key {
  background: #fd3e3e;
  color: #ffffff;
  border-color: #fd3e3e;
}

.speci_list div {
  min-width: 2.4rem;
  padding: 0 0.5rem;
  height: 0.96rem;
  font-size: 0.48rem;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  line-height: 0.96rem;
  text-shadow: 0px 0.06rem 0.48rem rgba(159, 159, 159, 0.42);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  text-align: center;
  margin-right: 0.4rem;
  margin-bottom: 0.4rem;
}

.sort {
  float: right;
}

.sort input {
  text-align: center;
  width: 2rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.56rem;
  color: #333;
  padding: 0 0.2rem;
  border: none;
}

.sort img {
  width: 1.04rem;
  height: 1.04rem;
}

.sf_exchangetip {
  font-size: 0.4rem;
  line-height: 0.6rem;
  color: #999;
  width: 100%;
  margin: 0.14rem 0.8rem 0.4rem;
}

.close {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
  width: 1rem;
  height: 1rem;
}
.custom-indicator.NewMode {
  right: 0rem;
  left: inherit;
  height: 1rem;
  line-height: 1rem;
  bottom: 0.7rem;
}
.swiper_text_x {
  width: 6.78rem;
  text-align: center;
}

/*---------------------- 分享模块 ---------------------*/

.share_image {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10580;
}

.share_image .shareImg {
  width: 12rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%);
}

.share_image .shareImg img {
  width: 100%;
  display: block;
}

.save_code,
.over_code {
  position: absolute;
  width: 100%;
  bottom: -1.8rem;
  left: 50%;
  transform: translate(-50%, 0);
  height: 1.5rem;
  background: rgba(253, 62, 62, 1);
  border-radius: 0.1rem;
  text-align: center;
  line-height: 1.7rem;
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 1);
}

.over_code {
  bottom: -3.6rem;
  background: #fff;
  color: #333333;
}

.reminder {
  width: 100%;
  height: 100%;
  background-color: rgba(170, 46, 46, 0.2);
  position: absolute;
  z-index: 100;
  top: 0;
}

.reminder_main {
  width: 93%;
  height: 30%;
  background-color: rgba(253, 62, 62, 1);
  margin: auto;
  margin-top: 45%;
}

/*---------------------- 分享模块 end ----------------------*/
</style>
<style>
.shop {
  background: #f4f6f8;
  padding-bottom: 2rem;
}

.noscroll {
  background: #f4f6f8;
  overflow: hidden;
  height: 100vh;
}

.shop_del {
  width: 100%;
}

.shop_del img {
  vertical-align: top;
  width: 100% !important;
  display: block;
}

.shop_del image {
  vertical-align: top;
  width: 100% !important;
}

.new_mode_content {
  width: 14.2rem;
  border: 0.4rem;
  background: #ffffff;
  margin: 0.4rem auto;
  border-radius: 0.4rem;
}

.new_mode_content .top_orange {
  background: linear-gradient(90deg, #ff463a 0%, #ff6528 100%);
  border-radius: 0.4rem 0.4rem 0px 0px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.48rem;
  padding: 0 0.4rem 0 0.64rem;
  height: 2.2rem;
  line-height: 2.2rem;
}

.new_mode_content .left_max_jifen strong {
  font-size: 0.96rem;
  color: #ffffff;
  font-weight: bold;
  margin-right: 0.12rem;
}

.new_mode_content .left_max_jifen span {
  font-size: 0.48rem;
  color: #ffffff;
  margin-right: 0.28rem;
}

/* .new_mode_content .left_max_jifen b {
		text-decoration: line-through;
	} */

.hot_targ {
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.22rem 0 0.28rem;
  border: 1px solid rgba(255, 255, 255, 0.33);
  display: block;
  border-radius: 0.2rem;
  margin-top: 0.56rem;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 0.44rem;
}

.goods_desx_box_x {
  width: 13.16rem;
  margin: -0.4rem auto 0;
  padding: 0.64rem 0.4rem 0 0.64rem;
  border-radius: 0.4rem;
  background: linear-gradient(180deg, #fff1f1 0%, #ffffff 100%);
}

.goods_desx_box_x .goods_name {
  font-weight: 500;
  font-size: 0.6rem;
  color: #333;
  line-height: 0.8rem;
  /* height: 1.2rem; */
  margin-bottom: 0.2rem;
}

.targ_max_box {
  background: linear-gradient(
    90deg,
    rgba(255, 245, 236, 0.36) 0%,
    #feefea 100%
  );
  border-radius: 0.16rem;
  border: 1px solid #f4d7d7;
  color: #ff463a;
  font-size: 0.48rem;
  /* height: 1rem; */
  /* line-height: 1rem; */
  padding: 0.18rem 0.4rem 0.18rem 0.2rem;
  margin: 0 0 0.4rem;
}

.targ_max_box span {
  /* height: 0.64rem;
		line-height: 0.66rem; */
  border-radius: 0.12rem;
  color: #ffffff;
  padding: 0 0.2rem;
  margin-right: 0.2rem;
  /* vertical-align: middle; */
  border: 1px solid transparent;
  /* display: inline-block; */
}
.targ_max_box .targ_store {
  background: #ffebe6;
  border-color: #ff5736;
  color: #ff5736;
  /* height: 0.64rem;
			    line-height: 0.66rem; */
  padding: 0 0.2rem;
}

.orange_bg {
  background: #ff8904;
}

.targ_max_box .black {
  background: #332a1f;
  color: #ffdcb1;
}

.characteristic {
  padding: 0.56rem 0 0.48rem;
  color: #333333;
  font-size: 0.48rem;
  border-top: 1px solid #f6f6f6;
}

.characteristic div {
  height: 0.56rem;
  /* line-height: 0.56rem; */
  display: flex;
  align-items: center;
}

.characteristic img {
  width: 0.56rem;
  height: 0.56rem;
  margin-top: -0.1rem;
  margin-right: 0.12rem;
  display: inline-block;
  border: 0 none;
}

.city.new_city_s {
  width: 14.2rem;
  margin: 0 auto;
  height: 1.76rem;
  line-height: 1.76rem;
  background: #ffffff;
  border-radius: 0.4rem;
  padding: 0;
}

.city.new_city_s .send {
  margin-left: 0.6rem;
  line-height: 1.76rem;
  color: #333333;
  font-size: 0.56rem;
  font-weight: 400;
}

.city.new_city_s .iconright {
  margin-right: 0.64rem;
}

.city.new_city_s .city_title {
  line-height: 1.76rem;
}

.shop_del.new_img_Box {
  width: 14.2rem;
  margin: 0 auto;
}
.more_suggest {
  width: 14.2rem;
  margin: 0.4rem auto 0;
  background: #ffffff;
  border-radius: 0.4rem;
}
.more_suggest .text_h1 {
  color: #333333;
  font-size: 0.56rem;
  padding: 0.6rem 0 0.6rem 0.6rem;
  font-weight: 500;
}
.more_suggest ul {
  padding: 0 0.6rem;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.more_suggest li {
  width: 4.12rem;
  margin-bottom: 0.4rem;
  margin-right: 0.32rem;
}
.more_suggest li:nth-child(3n) {
  margin-right: 0;
}
.more_suggest li p {
  height: 1.24rem;
  line-height: 0.64rem;
  font-size: 0.48rem;
  margin: 0.16rem 0 0.12rem;
}
.more_suggest li img {
  width: 4.12rem;
  height: 4.12rem;
  border-radius: 0.4rem;
  display: block;
}
.more_suggest .price {
  color: #ff463a;
  font-size: 0.4rem;
  height: 0.56rem;
  line-height: 0.56rem;
}
.more_suggest .price strong {
  color: #ff463a;
  font-size: 0.56rem;
  font-weight: bold;
  margin-right: 0.08rem;
}
.bot.new_footer {
  justify-content: space-between;
}
.bot.new_footer .operation div {
  width: 4.8rem;
  height: 1.44rem;
  line-height: 1.44rem;
  border-radius: 0.72rem;
  color: #ffffff;
}
.bot.new_footer .add_car {
  background: #ffbd02;
  margin-right: 0.4rem;
}
.bot.new_footer .operation {
  flex: inherit;
  margin-right: 0.4rem;
  margin-top: 0.38rem;
}
.bot.new_footer .collection img {
  width: 0.64rem;
  height: 0.64rem;
}
.bot.new_footer .collection.left_home {
  margin-left: 0.4rem;
}
.bot.new_footer .collection div {
  color: #333;
}
.city.new_city_s .city_title {
  margin-right: 0.4rem;
}
.add_car_img.share_newMode {
  right: 2.4rem;
}

.my-swipe_vertical {
  height: 1rem;
  line-height: 1rem;
  width: 6.78rem;
  /* padding:0 0.76rem ; */
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0.7rem;
  top: inherit;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  font-size: 0.44rem;
  border-radius: 0 0.5rem 0.5rem 0;
  overflow: hidden;
}
</style>